enum ContractType{
    long = "long", 
    casual = "casual", 
}

export default ContractType;